export default __webpack_public_path__ + "static/media/2252.852116ff.png";